const validate = (values) => {
    const errors = {};
    const fields = {
        email: 'global.email',
        password: 'global.login',
    };
    const requiredFields = Object.keys(fields);

    requiredFields.forEach((field) => {
        if (!values[field] || (values[field] && values[field].trim() === '')) {
            errors[field] = 'error.required';
        }
    });

    if (values.password && values.password.length < 8) {
        errors.password = 'error.minlength';
    }

    // eslint-disable-next-line no-useless-escape
    if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(values.email))) {
        errors.email = 'error.invalid';
    }

    return errors;
};

export default validate;
